import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

type LabelTimeHourProps = {
  time: number;
  zeroValue?: string;
};
const LabelTimeHour = (props: LabelTimeHourProps) => {
  //#region Destructuring Props
  const { time, zeroValue } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/common']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Implement Hook
  const formattedHour = useMemo(() => {
    const timeInMinute = Math.floor(time / 60);
    if (!timeInMinute && zeroValue) return zeroValue;

    const hourText = t('timeFormat.shortHours', { ns: 'admin/common' });
    const minuteText = t('timeFormat.shortMinutes', { ns: 'admin/common' });

    if (timeInMinute < 60) return `${timeInMinute} ${minuteText}`;
    const hour = Math.floor(timeInMinute / 60);
    const minutes = timeInMinute - hour * 60;

    return `${hour} ${hourText}` + (minutes ? ` ${minutes} ${minuteText}` : '');
  }, [zeroValue, t, time]);
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function
  return formattedHour;
};

export default memo(LabelTimeHour);
